// 'use client';

// React Imports
import type { ReactElement } from 'react';

// Type Imports
import type { SystemMode } from '../@core/types';

import useLayoutInit from '../@core/hooks/useLayoutInit';
// Hook Imports
import { useSettings } from '../@core/hooks/useSettings';

type LayoutWrapperProps = {
  systemMode: SystemMode;
  verticalLayout: ReactElement;
  horizontalLayout: ReactElement;
};

export const LayoutWrapper = (props: LayoutWrapperProps) => {
  // Props
  const { systemMode, verticalLayout, horizontalLayout } = props;

  // Hooks
  const { settings } = useSettings();

  useLayoutInit(systemMode);

  // Return the layout based on the layout context
  return (
    <div className="flex flex-col flex-auto" data-skin={settings.skin}>
      {settings.layout === 'horizontal' ? horizontalLayout : verticalLayout}
    </div>
  );
};
